import { useAuthStore } from "@stores"
import { PermissionString } from "@/types"

interface UsePermissionOptions {
  requireAll?: boolean
}

export function usePermission(
  permission: PermissionString | PermissionString[],
  options: UsePermissionOptions = { requireAll: false }
): boolean {
  const permissions = useAuthStore((state) => state.permissions)

  if (!permission || (Array.isArray(permission) && permission.length === 0)) {
    return false
  }

  if (Array.isArray(permission)) {
    if (options.requireAll) {
      return permission.every((p) => !!permissions[p])
    }

    return permission.some((p) => !!permissions[p])
  }

  return !!permissions[permission]
}
